import { divIcon, type DivIcon } from 'leaflet';
import type { NoddiIconName } from 'noddi-ui-common';
import { MARKER_BLUE, MARKER_RED } from './constants';
import { circularBadgeMarkerHtml, pairedCircularBadgeMarkerHtml } from './mapBadgeMarker';

/**
 * Start / end address icons for capacity contributions and worker address pairs.
 * - Start: Lucide `Play` (shift / route starts here)
 * - End: Lucide `Flag` (shift / route finishes here)
 */
export const START_ADDRESS_ICON_NAME = 'Play' satisfies NoddiIconName;
export const END_ADDRESS_ICON_NAME = 'Flag' satisfies NoddiIconName;

export const START_ADDRESS_MARKER_COLOR = MARKER_BLUE;
export const END_ADDRESS_MARKER_COLOR = MARKER_RED;

// Paths from lucide-react-native v0.542 (Play / Flag). Keep in sync when upgrading lucide.
const PLAY_PATHS = ['M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z'] as const;

const FLAG_PATHS = [
  'M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528'
] as const;

const startAddressLeafletIcon = divIcon({
  className: '',
  iconSize: [36, 36],
  iconAnchor: [18, 18],
  popupAnchor: [0, -18],
  html: circularBadgeMarkerHtml(PLAY_PATHS, START_ADDRESS_MARKER_COLOR)
});

const endAddressLeafletIcon = divIcon({
  className: '',
  iconSize: [36, 36],
  iconAnchor: [18, 18],
  popupAnchor: [0, -18],
  html: circularBadgeMarkerHtml(FLAG_PATHS, END_ADDRESS_MARKER_COLOR)
});

const addressPairLeafletIcon = divIcon({
  className: '',
  iconSize: [74, 36],
  iconAnchor: [37, 18],
  popupAnchor: [0, -18],
  html: pairedCircularBadgeMarkerHtml(PLAY_PATHS, START_ADDRESS_MARKER_COLOR, FLAG_PATHS, END_ADDRESS_MARKER_COLOR)
});

export const getStartAddressLeafletIcon = (): DivIcon => startAddressLeafletIcon;

export const getEndAddressLeafletIcon = (): DivIcon => endAddressLeafletIcon;

/** Combined start+end badge when both addresses share the same coordinates. */
export const getAddressPairLeafletIcon = (): DivIcon => addressPairLeafletIcon;

/** SVG path list for React legend icons that must match the leaflet marker glyphs. */
export const START_ADDRESS_ICON_PATHS = PLAY_PATHS;
export const END_ADDRESS_ICON_PATHS = FLAG_PATHS;
